
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`How well the candidate answered the question against the hirer's preferences.`}</p>
    <p>{`The score is calculated differently based on the `}<inlineCode parentName="p">{`responseTypeCode`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`For `}<inlineCode parentName="p">{`FreeText`}</inlineCode>{`, the score will be null.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For `}<inlineCode parentName="p">{`MultiSelect`}</inlineCode>{`, the score will be between 0 and 1 as a floating point.
For example, if the candidate selected half of the preferred answers, the score would be 0.5.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For `}<inlineCode parentName="p">{`SingleSelect`}</inlineCode>{`, the score will be either 1 or 0 based off whether or not the candidate selected a preferred answer.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;